import { useState } from 'react';
import { Button, Modal } from '@/components/ui';
import { motenApi } from '@/lib/api';
import { Besked } from './MotesDelar';
import { felText } from './motesText';

interface Props {
  mote: { id: string; titel: string } | null;
  /** Ligger mötet i kunskapsbasen? (Okänt för admin utan åtkomst.) */
  iKunskapsbasen?: boolean;
  onStang: () => void;
  onRaderat: () => void;
}

/** Bekräftelse innan ett möte raderas. Radering går inte att ångra. */
export function RaderaMote({ mote, iKunskapsbasen, onStang, onRaderat }: Props) {
  const [raderar, setRaderar] = useState(false);
  const [fel, setFel] = useState<string | null>(null);

  function stang() {
    if (raderar) return;
    setFel(null);
    onStang();
  }

  async function radera() {
    if (!mote) return;
    setRaderar(true);
    setFel(null);
    try {
      await motenApi({ atgard: 'radera', id: mote.id });
      onRaderat();
    } catch (e) {
      setFel(felText(e, 'Raderingen'));
    } finally {
      setRaderar(false);
    }
  }

  return (
    <Modal open={mote !== null} onClose={stang} title="Radera mötet" size="md">
      <div className="p-5 space-y-4">
        <p className="text-[13.5px] text-ink-800 leading-relaxed">
          <span className="font-semibold text-ink-900">{mote?.titel}</span> raderas med ljud, utskrift och
          sammanfattning
          {iKunskapsbasen === undefined
            ? ' – och tas bort ur kunskapsbasen om det ligger där'
            : iKunskapsbasen
              ? ', och tas bort ur kunskapsbasen'
              : ''}
          . Det går inte att ångra.
        </p>
        {fel && <Besked ton="fel">{fel}</Besked>}
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={stang} disabled={raderar}>
            Avbryt
          </Button>
          <Button variant="danger" onClick={() => void radera()} loading={raderar}>
            Radera mötet
          </Button>
        </div>
      </div>
    </Modal>
  );
}
